import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { ProvisionDigitalWalletTokenRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { ProvisionDigitalWalletTokenResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const provisionDigitalWalletToken = (
  request: ProvisionDigitalWalletTokenRequest,
  options?: CashRequestOptions
) =>
  post<ProvisionDigitalWalletTokenRequest, ProvisionDigitalWalletTokenResponse>(
    '/2.0/cash/provision-digital-wallet-token',
    request,
    { ...options, rejectOnError: true }
  )
